import { z } from 'zod';

export const addressSchema = z.object({
  streetAddressPartOne: z.string(),
  streetAddressPartTwo: z.string(),
  city: z.string(),
  state: z.string(),
  postalCode: z.string(),
  county: z
    .string()
    .nullish()
    .transform((val) => (val === null ? undefined : val))
    .optional(),
  latitude: z.number().optional(),
  longitude: z.number().optional(),
});

export const requiredStreetAddress = addressSchema
  .omit({ streetAddressPartOne: true })
  .and(
    z.object({
      streetAddressPartOne: z.string().min(1, 'Street address is required'),
    }),
  );
